import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';
import SettingsView from '../../ui/views/Settings/Settings';
import {apiClient} from "../../services/api";
import {fetchDevices, loadSystem} from "../../connectors/Devices/actions";
import NoDevice from "../../ui/views/Dialog/NoDevice";
import { whiteLabelData } from '../../ui/theme'
import log from 'loglevel'
import { t } from 'i18next';

var pageTitle = ""
const title = whiteLabelData.name


const mapStateToProps = state => (
  {
  title: state.application.title,
  map: state.devices.map,
  currentDevice: (state.devices.map[state.devices.active] || { settings: {} }),
  // settings: (state.devices.map[state.devices.active].state.varlist), //|| { settings: {} }).deviceVarList,
  currentDeviceId: (state.devices.map[state.devices.active] || { settings: {} }).deviceid,
  currentDeviceName: (state.devices.map[state.devices.active] || { settings: {} }).label
}
);

const mapDispatchToProps = dispatch => ({
  loadSystem: (val) => dispatch(loadSystem(val)),
  fetchDevices: () => dispatch(fetchDevices()),
});

/**
 * Settings
 */
class Settings extends PureComponent {
  static propTypes = {
  }

  static defaultProps = {
  }

  constructor(props) {
    super(props)
    this.state.deviceVarList = this.props.settings
    // log.debug(this.state)
  }

  state = {
    // loading: false,
    deviceVarList: [],
    gateWayData: '',

  }

  componentDidMount() {
  }

  componentWillMount(){
    pageTitle = t('PageTitles.settings')
    log.debug("SETTINGS WILL MOUNT")
    log.debug(this.props)
    this.secondLoad()
  }

  componentWillUnmount(){

  }

  // shouldComponentUpdate() {
  //   return true;
  // }

  componentWillReceiveProps(nextProps, nextContext) {
    // log.debug("componentWillReceiveProps", nextProps)
  }

  parseVarlistToSettings() {
    this.setState({settings: {filters: {uptimeLimit : this.state.deviceVarList.id_55, uptime: this.state.deviceVarList.id_167}, thresholds: {co2_set: 1111, humi_set:63}}})
  }

  secondLoad = () => {
    var data = { deviceid: this.props.currentDeviceId }
    log.debug("SECONDLOAD")
    apiClient.post('control/settings/store', data)
      .then(res => {
        if (res.status === 200) {
          log.debug("STATE UPDATE CMD OK")
          this.props.fetchDevices()
        }
      })
      .then(()=> {
        setTimeout(() =>{
          this.props.fetchDevices()
            log.debug("2 Seconds LATER")

      }, 2000)
      })
  }

  onFilterReset = (newDays) => {
    var data = {deviceid: this.props.currentDeviceId, filterresttime: newDays}// KDtimeToDays(this.state.deviceVarList.id_55)}
    apiClient.post('control/settings/filterreset', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // return res
        //  this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Filter reset", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onFilterMaxUptimeChange = (maxDays) => {
    log.debug(this.state)
    log.debug(maxDays)
    var data = {deviceid: this.props.currentDeviceId, filterMaxUptime: maxDays}
    log.debug(data)
    apiClient.post('control/settings/changefiltermaxuptime', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Max Filter Uptime Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onFilterParamsChange = (newDays, maxDays) =>{
    log.debug(this.state)
    log.debug(maxDays)
    log.debug(newDays)
    var data = {deviceid: this.props.currentDeviceId, filterresttime: newDays, filterMaxUptime: maxDays}
    log.debug(data)
    apiClient.post('control/settings/filterparamschange', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Filter Params Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onCoCoThresholdChange = (newThreshold) => {
    log.debug(this.state)
    log.debug(newThreshold)
    var data = {deviceid: this.props.currentDeviceId, coCoThreshold: newThreshold}
    log.debug(data)
    apiClient.post('control/settings/changecocothreshold', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on COCO threshold Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onHumiThresholdChange = (newThreshold) => {
    log.debug(this.state)
    log.debug(newThreshold)
    var data = {deviceid: this.props.currentDeviceId, humiThreshold: newThreshold}
    log.debug(data)
    apiClient.post('control/settings/changehumithreshold', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Humi threshold Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onThresholdsChange = (newCoCoThreshold, newHumiThreshold) =>{
    log.debug(this.state)
    log.debug(newCoCoThreshold)
    log.debug(newHumiThreshold)
    var data = {deviceid: this.props.currentDeviceId,coCoThreshold: newCoCoThreshold, humiThreshold: newHumiThreshold}
    log.debug(data)
    apiClient.post('control/settings/thresholdschange', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Thresholds Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onSlumberTimeChange = (newTime) => {
    log.debug(this.state)
    log.debug(newTime)
    var data = {deviceid: this.props.currentDeviceId, slumberTime: newTime}
    log.debug(data)
    apiClient.post('control/settings/changeslumbertime', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Slumbertime Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")
  }

  onTimeDateChange = (newDate, newTime) => {

    var data = {deviceid: this.props.currentDeviceId, date: newDate, time: newTime}

    log.debug(data)
    apiClient.post('control/settings/changedatetime', data)
    .then((res) => {
      if(res.status === 200){
        log.debug("ok")
        log.debug(res)
        // this.onMyLoad()
      }
    })
    .catch((err) => {
      log.error("Error on Date and Time Change", err.status)
      log.error(err.json)
    })
    log.debug("after try catch")

  }



  onSummerVentChange = (newVal) => {
    log.debug(this.state)
    log.debug(newVal)

    var data = { deviceid: this.props.currentDeviceId, summerVentActive: newVal }

    log.debug(data)
    apiClient.post('control/settings/changesummerventmode', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
          // this.onMyLoad()
        }
      })
      .catch((err) => {
        log.error("Error on Summer Ventilation Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }

  onTimeSynchChange = (newVal) => {
    log.debug(this.state)
    log.debug(newVal)

    var data = { deviceid: this.props.currentDeviceId, timeSynchActive: newVal }

    log.debug(data)
    apiClient.post('control/settings/changetimesynchmode', data)
      .then((res) => {
        if (res.status === 200) {
          log.debug("ok")
          log.debug(res)
          // this.onMyLoad()
        }
      })
      .catch((err) => {
        log.error("Error on Time Synchronisation Change", err.status)
        log.error(err.json)
      })
    log.debug("after try catch")
  }


  parseGatewayData(gw_data_raw, deviceid) {
    let rawdata_gw_articlecode = gw_data_raw.app_name
    let separatorPos = rawdata_gw_articlecode.indexOf("-", 0)
    let gateWayData = {
      articlecode: rawdata_gw_articlecode.replace("CEW0037S", "CEW0037E").slice(0, separatorPos),
      fw_version: gw_data_raw.fw_version,
      id: deviceid.replace("esp32_", ""),
      time_sync_enable: gw_data_raw.time_sync_enable,
    }
    return gateWayData
  }


  render() {
    // const { loading } = this.state;

     log.debug(this.props)
    //  log.debug(this._reactInternalFiber._debugOwner.stateNode)
    // if (!loading) {
      // log.debug(this.props.settings)
      // log.debug(this.state)
      if (this.props.currentDevice.state === undefined) {
        return <NoDevice></NoDevice>;
      }
      return (

        <SettingsView
          title={this.props.currentDeviceName + " - " + pageTitle}
          currentDeviceId={this.props.currentDeviceId}
          // settings={this.props.settings}
          // settings = {this.state.deviceVarList}
          settings = {this.props.currentDevice.state.varlist}
          // gateWayData={this.state.gateWayData}
          gateWayData = {this.parseGatewayData(this.props.currentDevice.state.gateway, this.props.currentDeviceId)}
          onFilterReset={this.onFilterReset}
          // onMyLoad={this.onMyLoad}
          // onMyLoad={this.props.fetchDevices}
          onMyLoad={this.secondLoad}
          onFilterMaxUptimeChange = {this.onFilterMaxUptimeChange}
          onFilterParamsChange = {this.onFilterParamsChange}
          onCoCoThresholdChange = {this.onCoCoThresholdChange}
          onHumiThresholdChange = {this.onHumiThresholdChange}
          onThresholdsChange = {this.onThresholdsChange}
          onSlumberTimeChange = {this.onSlumberTimeChange}
          // onSummerVentilationChange = {this.onSummerVentilationChange}
          onSummerVentChange = {this.onSummerVentChange}
          onTimeSynchChange = {this.onTimeSynchChange}
          onTimeDateChange = {this.onTimeDateChange}
          //  settings = {this.state.deviceVarList}

        />
      );
    // } else {
    //   return (<img style={{ width: '100%', maxWidth: '300px',  }} src={whiteLabelData.logo} alt="loading..."/> )
    // }
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings)), title);
